import React from 'react';

export const data = [
    {
        id:"1",
        name:"Product list",
        status:<i className="fa fa-circle font-warning f-12"></i>,
        create_on:"Sep 5,18",
    },
    {
        id:"2",
        name:"Digital Product",
        status:<i className="fa fa-circle font-danger f-12"></i>,
        create_on:"Mar 10,18",
    },
    {
        id:"3",
        name:"User Media",
        status:<i className="fa fa-circle font-success f-12"></i>,
        create_on:"Aug 24,18",
    },
    {
        id:"4",
        name:"About Product",
        status:<i className="fa fa-circle font-success f-12"></i>,
        create_on:"Jun 12,18",
    },
    {
        id:"5",
        name:"User Profile",
        status:<i className="fa fa-circle font-warning f-12"></i>,
        create_on:"May 26,18",
    },
    {
        id:"6",
        name:"Discount Product",
        status:<i className="fa fa-circle font-danger f-12"></i>,
        create_on:"Sep 13,18",
    },
    {
        id:"7",
        name:"About Invoice",
        status:<i className="fa fa-circle font-success f-12"></i>,
        create_on:"Dec 30,18",
    }
]

export default data

  